import { render, staticRenderFns } from "./xuekeyaoqiu.vue?vue&type=template&id=64a49389&scoped=true"
import script from "./xuekeyaoqiu.vue?vue&type=script&lang=js"
export * from "./xuekeyaoqiu.vue?vue&type=script&lang=js"
import style0 from "./xuekeyaoqiu.vue?vue&type=style&index=0&id=64a49389&prod&lang=less&scoped=true"
import style1 from "./xuekeyaoqiu.vue?vue&type=style&index=1&id=64a49389&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a49389",
  null
  
)

export default component.exports